// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Blog_contentWrapper__7VVG4","blogDataWrapper":"Blog_blogDataWrapper__ypDVQ","buttonWrapper":"Blog_buttonWrapper__+UBko"};